import { createContext } from 'react';

export type PaymentContextType = {
  renderITPBanks: boolean;
  setRenderITPBanks: (value: boolean) => void;
  startRedirect: boolean;
};

const PaymentContext = createContext<PaymentContextType>({
  renderITPBanks: false,
  setRenderITPBanks: () => {},
  startRedirect: false,
});

export default PaymentContext;
